import {
  BREAKPOINTS_V3,
  GridItem,
  LayoutGrid,
  useMediaQuery,
} from '@jouzen/ecom-components';

import { PhotoGrid } from '@/app/components/PhotoGrid';
import SectionHeading from '@/app/components/SectionHeading';

import {
  desktopPhotoGrid,
  mobilePhotoGrid,
} from './data/popLifestylePhotoGrids';

export function PopLifestyle(): JSX.Element {
  const matchLargeScreen = useMediaQuery(
    `(min-width: ${BREAKPOINTS_V3.large}px)`,
  );

  return (
    <section className="relative pt-16">
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <div className="relative z-10 md:flex md:justify-center">
            <SectionHeading
              animated
              content="pop_lifestyle_title"
              indentation="pl-8"
              multiline={!matchLargeScreen}
              typographyProps={{
                className:
                  'text-heading-2xl leading-heading mb-6 tracking-tighter relative z-10 md:text-[3rem] lg:mb-0 lg:leading-none lg:text-center lg:translate-y-full lg:text-[4.25rem] lg:tracking-[-2px]',
                color: 'inherit',
                Element: 'h2',
                variant: 'h2',
              }}
            />
          </div>
        </GridItem>
        <GridItem
          className="overflow-hidden"
          colEnd={{ sm: 'full' }}
          colStart={{ sm: 'full' }}
        >
          <div className="lg:hidden">
            <PhotoGrid {...mobilePhotoGrid} />
          </div>
          <div className="hidden lg:block">
            <PhotoGrid {...desktopPhotoGrid} />
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
}
